<%
  var specialPayors = AppointmentBooking.config.special_payors;
  var selectedPayor = AppointmentBooking.config.payors.find(function(payor) { return String(payor.id) === String(payor_id) });
  var isSelfPay = String(payor_id) === String(specialPayors.no_insurance);
  var carrier = String(payor_id) === String(specialPayors.not_listed) ? insurance_name : (selectedPayor && selectedPayor.name);
%>

<div class="field-label"><%= I18n.confirmation.labels.insurance %></div>

<div class="insurance-review" data-testid="<%= testIds.registration.insuranceReview %>">
  <% if (isSelfPay) { %>
    <div class="insurance-review__carrier"><%= I18n.confirmation.values.self_pay %></div>
  <% } else { %>
    <div class="insurance-review__carrier" translate="no"><%- carrier %></div>

    <% if (member_number) { %>
      <div class="insurance-review__detail">
        <%= I18n.insurance.labels.member_number %>: <span translate="no"><%- member_number %></span>
      </div>
    <% } %>

    <% if (group_number) { %>
      <div class="insurance-review__detail">
        <%= I18n.insurance.labels.group_number %>: <span translate="no"><%- group_number %></span>
      </div>
    <% } %>
  <% } %>
</div>
